
import { useServiceCatalog } from '@/services/useServiceCatalog'
import sectionLayoutContent from '@/components/common/section-layout-content.vue'
import Editor from '@/pages/admin/catalog/components/Editor.vue'
import DropVariants from '@/pages/admin/catalog/components/DropVariants.vue'
import UploadImage from '@/components/common/UploadImage.vue'
import { useRoute, useRouter } from 'vue-router'
import { Delete } from '@element-plus/icons'
import {
  reactive,
  defineComponent,
  ref,
  computed,
  onBeforeMount,
  onMounted,
} from 'vue'
import { Variant } from '@/interfaces/catalog'
import userCatalogRepositories from '@/repositories/userCatalogRepositories'
import { useFetchData, useNotification } from '@/composables'
import { stringRules } from '@/utils/formRules'
import axios from '@/services/axios'
import { SHIPPING_METHOD_DROPSHIP } from '@/utils/constants'
import {
  getPublishStatusName,
  getPublishStatusTagColor,
  PUBLISH_STATUS_ARR,
  CATALOG_PUBLISH_STATUS,
  SupplierLogType,
} from '@/utils/catalog'
import HistoryChangeDialog from '@/pages/admin/supplier-catalog/components/HistoryChangeDialog.vue'
import userSupplierLogRepositories, {
  SupplierLog,
} from '@/repositories/userSupplierLogRepositories'

export default defineComponent({
  components: {
    sectionLayoutContent,
    Editor,
    UploadImage,
    DropVariants,
    Delete,
    HistoryChangeDialog,
  },
  name: 'Edit Dropship Catalog',
  setup() {
    const breadcrumbs = [
      {
        text: 'Catalog',
        link: '',
        params: null,
      },
      {
        text: 'Edit',
        link: '',
        params: null,
      },
    ]
    const content = computed(() => {
      return { breadcrumbs }
    })
    const costBy = ref('size')
    const catalog = reactive<any>({
      _id: '',
      name: '',
      categories: '',
      productCode: '',
      description: '',
      variants: [],
      sizes: [],
      colors: [],
      shipping: '',
      production: '',
      mockupGallery: [],
      designs: [],
      updateVariant: {
        add: [],
        delete: [],
      },
      // thêm mới để tạo drop
      dropship: true,
      isTrademark: false,
      publishStatus: 0,
      outOfStock: false,
      tags: [],
      niches: [],
      aboutDescription: '',
      returnDescription: '',
    })
    const isLoading = ref(true)
    const route = useRoute()
    const router = useRouter()
    const change = ref<boolean>(false)
    const addVariants = ref([])
    const deleteIds = ref<string[]>([])
    const { error, success, warning } = useNotification()
    const activeName = ref('description')
    const isUpdatedVariants = ref(false)
    const variantsInDropVariants = ref()

    // lay danh sach category
    const params = reactive({ page: 1, limit: 1000 })
    const { documents, fetchData } = useFetchData(`/catalog-categories`, params)
    const getData = async () => {
      isLoading.value = true
      const { getCatalog } = userCatalogRepositories()
      const { data } = await getCatalog(route.params.id)
      Object.assign(catalog, data)
      isLoading.value = false
    }
    onBeforeMount(() => {
      fetchData()
    })

    const selectedCountryCode = ref('US')
    const selectedShipMethod = ref('standard')

    // lay danh sach tags
    let tagList = ref([])
    const getTags = async () => {
      let res = await axios.get('/catalogs/common/tags')
      if (res?.status === 200 || res?.status === 201) {
        tagList.value = res.data as any
      }
    }

    // lay danh sach country
    let countries = ref([])
    let loadingCountries = ref(true)
    const getCountries = async () => {
      let res = await axios.get('/catalogs/common/countries')
      if (res?.status === 200 || res?.status === 201) {
        // thêm rest of world vào country list
        const ROWItem = {
          calling_code: '',
          code: 'ROW',
          id: 500,
          name: 'Rest Of World',
          province_required: false,
          provinces: null,
        } as any
        res.data.splice(0, 0, ROWItem)

        countries.value = res.data as any
      }
      loadingCountries.value = false
    }

    onMounted(() => {
      getData()
      getTags()
      getCountries()
    })

    const variantsTemp = ref<any[]>([])

    const changeDescription = (html: string, dataSet: any) => {
      dataSet.description = html
    }
    const changeAboutDescription = (html: string, dataSet: any) => {
      dataSet.aboutDescription = html
    }
    const changeReturnDescription = (html: string, dataSet: any) => {
      dataSet.returnDescription = html
    }

    const addDesign = (data: any, dataSet: any, status: any) => {
      if (status.index > -1) {
        dataSet.splice(status.index, 1, data)
      } else {
        dataSet.push(data)
      }
    }
    const callbackMockup = (setData: any, files: string[]) => {
      setData.mockupGallery = files
    }
    const changeProduction = (html: string, dataSet: any) => {
      dataSet.production = html
    }
    const changeShipping = (html: string, dataSet: any) => {
      dataSet.shipping = html
    }
    const changeMaterial = (html: string, dataSet: any) => {
      dataSet.material = html
    }
    const changeDescription2 = (html: string, dataSet: any) => {
      dataSet.description2 = html
    }
    const changeSizeGuide = (html: string, dataSet: any) => {
      dataSet.sizeGuide = html
    }

    const changeCostBy = (value: string) => {
      costBy.value = value
    }
    const delDesign = (index: number | 0) => {
      catalog?.designs?.splice(index, 1)
    }
    const _idVariants = ref<any[]>([])
    const callbackVariant = (
      colors: any[],
      sizes: any[],
      variants: Variant[],
      deleteVariantIds: string[]
    ) => {
      catalog.colors = colors
      catalog.sizes = sizes
      change.value = true
      catalog.variants = catalog.variants.concat(variants)
      addVariants.value = addVariants.value.concat(variants as any)
      deleteIds.value = deleteIds.value.concat(deleteVariantIds)
    }

    const callbackChangeOptionName = (
      displayColorName: string,
      displaySizeName: string
    ) => {
      catalog.displayColorName = displayColorName
      catalog.displaySizeName = displaySizeName
    }

    const rulesCatalog = {
      name: stringRules('name', 2, 128),
      categories: stringRules('categories', 2, 128),
      productCode: stringRules('product code', 2, 128),
    }
    const { update, updatePublishStatus, updateCatalogVariants } =
      userCatalogRepositories()
    const isSubmit = ref<boolean>(false)
    const catalogFormUpdate = ref<any>(null)

    const updatePublistStatusCatalogs = async (
      ids: string[],
      publishStatus: string
    ) => {
      try {
        if (!ids) {
          warning('List catalogs not found')
          return
        }
        if (!publishStatus) {
          warning('Status catalogs not found')
          return
        }
        const res = (await updatePublishStatus({
          ids: ids,
          status: publishStatus,
        })) as any
        if (res.status === 201 || res.status === 200) {
          success(`Success`)
          getData()
        } else {
          error(res.data.message)
        }
      } catch (e) {
        error()
      }
    }

    const { saveLog } = userSupplierLogRepositories()

    const updateCatalog = async () => {
      isSubmit.value = true
      catalogFormUpdate.value?.validate(async (valid: any) => {
        if (valid) {
          // luu variant da sua gia
          await updateCatalogVariants(catalog)

          // neu update variant thi ghi log
          const supplierLog = {
            catalog: catalog._id,
            variantChanged: variantsInDropVariants.value
              ? variantsInDropVariants.value
              : catalog.varaiant,
            status: catalog.publishStatus,
            note: catalog.note,
            type: SupplierLogType.ChangeSellerPrice,
          }
          if (isUpdatedVariants.value) {
            saveLog(supplierLog)
          }

          // luu catalog theo logic ban dau
          delete catalog.variants
          catalog.updateVariant = {
            add: addVariants,
            delete: deleteIds,
          }
          const { status, data } = await update(catalog)

          if (status === 200) {
            getData()
            isSubmit.value = false
            success('Updated')
          } else {
            error(data.message)
          }
        }
      })
    }

    const onAfterUpdateVariant = async (reload?: boolean, variants?: any) => {
      // danh dau la da update varaiant
      isUpdatedVariants.value = true
      variantsInDropVariants.value = variants
      if (reload) {
        loadingCountries.value = true
        const { getCatalog } = userCatalogRepositories()
        const { data } = await getCatalog(route.params.id)
        Object.assign(catalog, data)
        loadingCountries.value = false
      }
    }

    const dialog = ref<boolean>(false)
    const cancelDelete = () => {
      dialog.value = false
    }
    const deleteCatalog = () => {
      dialog.value = true
    }

    const confirmDelete = async () => {
      const { deleteById } = userCatalogRepositories()
      const { status, data } = await deleteById(catalog)
      if (status === 200) {
        router.push({ name: 'a.catalogs' })
      }
    }
    const discard = () => {
      // window.location.reload()
      router.push({
        name: 'a.catalogs',
      })
    }

    const historyChangeDialog = ref<InstanceType<typeof HistoryChangeDialog>>()
    const historyDialogToggle = (_id: string) => {
      historyChangeDialog.value?.toggle(_id, SupplierLogType.ChangeSellerPrice)
    }

    return {
      getData,
      historyChangeDialog,
      historyDialogToggle,
      route,
      router,
      content,
      catalog,
      costBy,
      changeDescription,
      changeDescription2,
      addDesign,
      callbackMockup,
      changeProduction,
      changeShipping,
      changeMaterial,
      changeCostBy,
      delDesign,
      useServiceCatalog,
      isLoading,
      callbackVariant,
      updateCatalog,
      change,
      variantsTemp,
      _idVariants,
      dialog,
      cancelDelete,
      deleteCatalog,
      confirmDelete,
      discard,
      isSubmit,
      catalogFormUpdate,
      rulesCatalog,
      changeAboutDescription,
      changeReturnDescription,
      documents,
      tagList,
      countries,
      selectedCountryCode,
      selectedShipMethod,
      SHIPPING_METHOD_DROPSHIP,
      callbackChangeOptionName,
      loadingCountries,
      updatePublistStatusCatalogs,
      CATALOG_PUBLISH_STATUS,
      getPublishStatusName,
      getPublishStatusTagColor,
      PUBLISH_STATUS_ARR,
      onAfterUpdateVariant,
      isUpdatedVariants,
      activeName,
      changeSizeGuide,
      variantsInDropVariants,
    }
  },
})
